import "./index.css";
import { Box, Typography } from "@mui/material";
import TeamMermberCard from "../../../Components/TeamMermberCard";
import sohan from "../../../assets/team/sohan.jpeg";
import subham from "../../../assets/team/subham.jpeg";

const OurTeam = () => {
  return (
    <Box className="journey-with-us-img section-divide">
      <Box className="container">
        <Box className="our-team-container">
          <Box className="section-header-light align-text-center">
            <Typography variant="h2">Professional Team</Typography>
            <Box className="cont">
              <p>
                Meet the members of our qualified team that can help you with
                your financial planning.
              </p>
            </Box>
          </Box>

          <Box className="team-grid">
            {/* <TeamMermberCard designation="CEO" name="Hariom" /> */}
            <TeamMermberCard
              designation="CEO"
              name="Sohanlal Tyagi"
              image={sohan}
            />
            <TeamMermberCard
              designation="Managing Director"
              name="Purnima Verma"
            />
            <TeamMermberCard
              designation="Additional Director"
              name="Subham Tyagi"
              image={subham}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OurTeam;
